import React, { useContext } from 'react';
import Modal from '@mui/material/Modal';
import { UploadCompaniesModal } from './upload-companies-modal';
import { UploadCompaniesContext } from '../../../../../../../providers/upload-companies-provider';

type Props = {
    closeModal: () => void;
    isOpen: boolean;
    exclude: boolean;
    includeValues: [];
    excludeValues: [];
};

export const UploadCompaniesModalContainer = ({ closeModal, isOpen, exclude, includeValues, excludeValues }: Props) => {
    const { resetAllValues } = useContext(UploadCompaniesContext);
    const modalStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const handleCloseModal = () => {
        closeModal();
        resetAllValues();
    };

    return (
        <Modal
            onClose={closeModal}
            open={isOpen}
            style={modalStyle}
            slotProps={{ backdrop: { style: { backgroundColor: '#60657B2E' } } }}
        >
            <UploadCompaniesModal
                isOpen={isOpen}
                closeModal={handleCloseModal}
                exclude={exclude}
                includeValues={includeValues}
                excludeValues={excludeValues}
            />
        </Modal>
    );
};
